module.exports = __webpack_public_path__ + "12f64172bfd35d61006bf72c13c668d9.png";